import React from 'react'

const TextSkeleton = (props) => {
  return (
    <div className={`${props.bgColor ? props.bgColor : "bg-primary-text"} skeleton ${props.rounded ? props.rounded : "rounded-full"} ${props.className || "w-36 xl:w-52 h-4"}`}></div>
  )
}

export default TextSkeleton